// alterado - revisado

import React from 'react'

import { FieldArray } from 'formik'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import MESSAGE from '../../../business-const/Message/Message'

import TAMMAX from '../../../business-rules/TamMax/TamMax'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    GridItem1,
    GridItem4,
    GridItem7,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    TextValidatorText,
    TextValidatorEmail,
    TextValidatorTelefone,
    TextValidatorCelular,
} from '../../../business-components/TextValidator/TextValidator'

import { 
    TextFieldTextSelect,
} from '../../../business-components/TextField/TextFieldSelect'

import {
    pesquisaList
} from '../../../business-rules/List/ListService'

import tipoContatoList from '../../../business-rules/List/tipoContatoList'

import {
    IconButtonClearEntradaDados
} from '../../../business-components/IconButton/IconButton'

import {
    ButtonIncluirLinha
} from '../../../business-components/Button/Button'

import {
    cadastrouEmailCliente,
} from '../cliente-form/ClienteService'

import {
    processaRegistrosDefaultIniciaisContato,
} from './CadastroServiceContato'



const CadastroFormContato = ({ familiar, values, handleChange, jsonConfiguracao }) => {

    processaRegistrosDefaultIniciaisContato(values, familiar)

    return (
        <FieldArray name="contatos">
            {(arrayHelpers) => (
                <DivForm>
                    <DivForm
                        style={{
                            display: values.contatos && values.contatos.filter(contato => contato.familiar === familiar).length > 0 ? "block" : "none"
                        }}
                    >
                        {values.contatos?.map((item, ind) => {
                            return item.familiar === familiar ? (
                                <GridContainer
                                    key={ind}
                                >
                                    <GridItem12>
                                        <GridContainer>
                                            <GridItem4>
                                                <TextFieldTextSelect
                                                    name={`contatos[${ind}].tipoContato`}
                                                    label={LABEL.tipoContato}
                                                    value={item.tipoContato || ''}
                                                    onChange={handleChange}
                                                    list={tipoContatoList}
                                                />
                                            </GridItem4>
                                            <GridItem7
                                                style={{
                                                    display: 
                                                        !item.tipoContato
                                                            ? "block"
                                                            : "none"
                                                }} 
                                            />
                                            <GridItem7
                                                style={{
                                                    display: 
                                                        item.tipoContato
                                                            ? "block"
                                                            : "none"
                                                }} 
                                            >
                                                {
                                                    pesquisaList(tipoContatoList, 
                                                        item.tipoContato).formato === "email"
                                                        ?
                                                            <TextValidatorEmail
                                                                name={`contatos[${ind}].contato`}
                                                                label={LABEL.contato}
                                                                value={item.contato || ''}
                                                                onChange={handleChange}
                                                            />
                                                        :
                                                            pesquisaList(tipoContatoList, 
                                                                item.tipoContato).formato === "telef"
                                                                ?
                                                                    <TextValidatorTelefone
                                                                        name={`contatos[${ind}].contato`}
                                                                        label={LABEL.contato}
                                                                        value={item.contato || ''}
                                                                        onChange={handleChange}
                                                                    />
                                                                :
                                                                    pesquisaList(tipoContatoList, 
                                                                        item.tipoContato).formato === "cel"
                                                                        ?
                                                                            <TextValidatorCelular
                                                                                name={`contatos[${ind}].contato`}
                                                                                label={LABEL.contato}
                                                                                value={item.contato || ''}
                                                                                onChange={handleChange}
                                                                            />
                                                                        :
                                                                            <TextValidatorText
                                                                                name={`contatos[${ind}].contato`}
                                                                                label={LABEL.contato}
                                                                                value={item.contato || ''}
                                                                                onChange={handleChange}
                                                                                tamMax={TAMMAX.contato}
                                                                            />
                                                }
                                            </GridItem7>
                                            <GridItem1>
                                                <IconButtonClearEntradaDados
                                                    onClick={() =>
                                                        arrayHelpers.remove(ind)
                                                    }
                                                />
                                            </GridItem1>
                                        </GridContainer>
                                    </GridItem12>
                                </GridContainer>
                            )
                            : 
                            (
                                <DivForm
                                    key={ind}
                                />
                            )
                        })}
                    </DivForm>

                    {familiar === HARDCODE.idFamiliarCliente && jsonConfiguracao &&
                    jsonConfiguracao.tornarEmailClienteObrigatorio && !cadastrouEmailCliente(values) && (
                        <h6
                            className='text-error ml-1'
                        >
                            {MESSAGE().emailObrigatório}
                        </h6>
                    )}

                    <GridContainer>
                        <ButtonIncluirLinha
                            label={LABEL.buttonIncluirContato} 
                            onClick={() => 
                                arrayHelpers.push({
                                    familiar: familiar
                                })
                            }
                        />
                    </GridContainer>
                </DivForm>
            )}
        </FieldArray>
    )
}

export default CadastroFormContato